require('../module/dialog');

window.feedback = {

    init: function () {
        $('[feedback-form]').on('submit', feedback.send);

        if (typeof user !== 'undefined' && user && user.id != '0') {
            dialog.message.item = {
                '[message-message]': 'message',
                'function': function (data, html) {
                    if (!data.created_at) {
                        html.attr('sending', 'true');
                    }

                    $(html).find('[message-time]').html(
                        data.created_at
                            ? moment(data.created_at).format('h:mm')
                            : 'Отправка..'
                    );

                    if (!data.user || data.user.id == user.id) {
                        html.addClass('right');
                    }

                    return html;
                }
            };

            dialog.item = {
                'function': function (data, html) {
                    var src = data.user.images ? data.user.images[0] : false,
                        src = src ? image.url(src, 280) : '/img/user_default.png';

                    html.find('[dialog-image]').attr('src', src);
                    html.find('[dialog-name]').html(data.user.name);
                    html.find('[dialog-message]').html(data.message_text ? dialog.message.short(data.message_text, 100) : (data.user.position ? data.user.position : ''));
                    html.find('[dialog-time]').html(moment(data.updated_at).format('h:mm'));
                    html.find('[dialog-date]').html(moment(data.updated_at).format('DD.MM.YYYY'));

                    return html;
                }
            };

            dialog.list({
                page: 1,
                support: ['admin', 'moder'].indexOf(user.group) == -1 ? true : false
            }, function (json) {
                dialog.print(dialog.selector.list, json);
            });

            $(document)
                .on('click', '[dialog-list="openModal"] [dialog-item]', function () {
                    $('#uqauthModal').modal('show');
                })
                .on('click', dialog.selector.item, function () {
                    if (
                        $(this).attr('dialog-id') != dialog.id ||
                        $(this).attr('dialog-user-id') != dialog.user.id
                    ) {
                        dialog.id = $(this).attr('dialog-id');
                        dialog.user.id = $(this).attr('dialog-user-id');

                        $('[dialog-select-name]').html($(this).find('[dialog-name]').html());

                        feedback.messages();
                    }
                })
                .on('input', '[name="message_search"]', function () {
                    if (feedback.timeout) clearTimeout(feedback.timeout);
                    feedback.timeout = setTimeout(feedback.messages, 800);
                })
                .on('input', '[name="dialog_search"]', function () {
                    var search = $.trim($(this).val());
                    if (feedback.timeout) clearTimeout(feedback.timeout);
                    feedback.timeout = setTimeout(function () {
                        $(dialog.selector.list).html('');
                        dialog.list({
                            page: 1,
                            search: search
                        }, function (json) {
                            dialog.print(dialog.selector.list, json);
                        });
                    }, 800);
                })
                .on('submit', dialog.selector.message.form, function (e) {
                    e.preventDefault();

                    var form = $(this),
                        message = $.trim(form.find('[name="message"]').val());

                    if ((!message && !$('[name="attachs[]"]')[0].files.length) || (!dialog.id && !dialog.user.id) || dialog.message.ajax_send) {
                        return false;
                    }

                    dialog.print(dialog.selector.message.list, {
                        data: [{ message: message }]
                    });
                    $(dialog.selector.item + '.active [dialog-message]').html(dialog.message.short(message, 100));

                    dialog.message.send(form, function (json) {
                        dialog.print(dialog.selector.message.list, {
                            data: [json.data]
                        });
                    });

                    form.trigger('reset');

                    return false;
                })
                .on('change', '[name="attachs[]"]', function () {
                    $(this).parents('form').trigger('submit');
                });
        }
    },

    messages: function () {
        dialog.message.list({
            message: $.trim($('[name="message_search"]').val()),
            dialog_id: dialog.id,
            user_id: dialog.user.id,
            preloader: '<div class="text-center my-5"><div class="spinner-border text-dark" role="status"><span class="sr-only">Loading...</span></div></div>'
        }, function (json) {
            if (typeof json === 'object') {
                json.reverse = true;
            }
            dialog.print(dialog.selector.message.list, json);
        });
    },

    send: function (e) {
        e.preventDefault();

        var form = $(this);

        ajax({
            url: '/api/feedback',
            data: new FormData(form[0]),
            contentType: false,
            processData: false,
            type: 'post',
            dataType: 'json'
        }, function (json) {
            if (json.success) {
                alert(json.success);
                form.trigger('reset');
            }
        }, form);

        return false;
    }

}

feedback.init();